import React, { useEffect, useState, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { SERVER_URL } from "../../../config";
import alertSearch from "../../../assets/img/icons/alertSearch.svg";
import { Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import { FetchArticleById, FetchProfanityList } from "../submitArticle/queries";
import ViewHeaderLink from "../../../components/viewArticle/headerLink";
import Authors from "../../../components/viewArticle/authors";
import PublishedDate from "../../../components/viewArticle/publishedDate";
import ArticleLinks from "../../../components/viewArticle/articleLinks";
import TableOfContent from "../../../components/viewArticle/tableOfContent";
import LeftCommonLink from "../../../components/viewArticle/leftCommonLink";
import ContentDetails, { extractImagesFromHtml } from "../../../components/viewArticle/contentDetails";

import copy from "../../../assets/img/icons/copy.svg";
import src from "../../../assets/img/sample/coverImage.png";
import infoI from "../../../assets/img/icons/infoI.svg";
import copyC from "../../../assets/img/icons/copyC.svg";
import downloadImg from "../../../assets/img/sample/demo001.png";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import { saveArticleToDraft, notifySubmissionFailure } from "../../../store/apiCalls/articles";
import { checkEmptyArticle } from "../../../utils";
import active_info from "../../../svg/active-info.svg";
import { UploadMedia, UploadMediaWithName } from "../../../store/apiCalls/profileDetails";
import { extractManuscriptXml, generatePdfFromXml, parseExtractorError } from "../../../services/extractorApi";

function perviewArticle() {
  const router = useLocation();
  const articleIdFromUrl = router.pathname.split("/")[2];
  const [showSubmitSuccessModal, setShowSubmitSuccessModal] = useState(false);
  const [showUploadArticleModal, setShowUploadArticleModal] = useState(false);
  const [showNoFiguresModal, setShowNoFiguresModal] = useState(false);
  const [isUploadingArticle, setIsUploadingArticle] = useState(false);
  const [uploadFile, setUploadFile] = useState(null);
  const [imageList, setImageList] = useState([]);
  const [supplementaryList, setSupplementaryList] = useState([]);
  const [uploadErrorMessage, setUploadErrorMessage] = useState("");
  const imageInputRef = useRef(null);
  const documentInputRef = useRef(null);
  const supplementaryInputRef = useRef(null);

  const ALLOWED_SUPPLEMENTARY_EXTENSIONS = [
    "pdf",
    "doc",
    "docx",
    "xls",
    "xlsx",
    "jpg",
    "jpeg",
    "png",
  ];

  const handleAddSupplementaryFiles = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFiles = Array.from(e.target.files);
      const invalidFiles = selectedFiles.filter((file) => {
        const ext = file.name.split(".").pop()?.toLowerCase();
        return !ALLOWED_SUPPLEMENTARY_EXTENSIONS.includes(ext);
      });

      if (invalidFiles.length > 0) {
        toast.error(
          "Only PDF, WORD, EXCEL, and JPG/PNG formats are allowed for Supplementary Material.",
        );
        e.target.value = null;
        return;
      }

      const newItems = selectedFiles.map((file, idx) => ({
        id:
          Date.now() +
          "_" +
          idx +
          "_" +
          Math.random().toString(36).substr(2, 4),
        file,
        name: file.name,
        size: file.size,
      }));
      setSupplementaryList((prev) => [...prev, ...newItems]);
      e.target.value = null;
    }
  };

  const handleRemoveSupplementaryFile = (id) => {
    setSupplementaryList((prev) => prev.filter((item) => item.id !== id));
  };

  const handleAddImages = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const newItems = Array.from(e.target.files).map((file, idx) => ({
        id: Date.now() + "_" + idx + "_" + Math.random().toString(36).substr(2, 4),
        file,
        title: file.name,
      }));
      setImageList((prev) => [...prev, ...newItems]);
      e.target.value = null;
    }
  };

  const handleUpdateImageTitle = (id, newTitle) => {
    setImageList((prev) =>
      prev.map((item) => (item.id === id ? { ...item, title: newTitle } : item))
    );
  };

  const handleRemoveImage = (id) => {
    setImageList((prev) => prev.filter((item) => item.id !== id));
  };

  const extractAndUploadPdfImages = async (pdfFile, uploadMediaFn) => {
    try {
      if (typeof window.pdfjsLib === "undefined") {
        await new Promise((resolve, reject) => {
          const script = document.createElement("script");
          script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js";
          script.onload = () => resolve();
          script.onerror = () => reject(new Error("Failed to load PDF.js script"));
          document.head.appendChild(script);
        });
      }

      const pdfjsLib = window.pdfjsLib;
      pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js";

      const arrayBuffer = await pdfFile.arrayBuffer();
      const pdfDoc = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

      const extractedImageUrls = [];
      const imageMap = {};
      let imageCounter = 1;

      for (let pageNum = 1; pageNum <= pdfDoc.numPages; pageNum++) {
        const page = await pdfDoc.getPage(pageNum);
        const ops = await page.getOperatorList();

        for (let i = 0; i < ops.fnArray.length; i++) {
          if (
            ops.fnArray[i] === pdfjsLib.OPS.paintImageXObject ||
            ops.fnArray[i] === pdfjsLib.OPS.paintInlineImageXObject
          ) {
            const imgName = ops.argsArray[i][0];
            let imgObj;
            try {
              imgObj = page.objs.get(imgName);
            } catch (e) {
              continue;
            }

            if (!imgObj || !imgObj.width || !imgObj.height || imgObj.width < 50 || imgObj.height < 50) {
              continue;
            }

            const canvas = document.createElement("canvas");
            canvas.width = imgObj.width;
            canvas.height = imgObj.height;
            const ctx = canvas.getContext("2d");

            const imgData = ctx.createImageData(imgObj.width, imgObj.height);
            const data = imgObj.data;

            if (data.length === imgObj.width * imgObj.height * 4) {
              imgData.data.set(data);
            } else if (data.length === imgObj.width * imgObj.height * 3) {
              let j = 0;
              for (let k = 0; k < data.length; k += 3) {
                imgData.data[j] = data[k];
                imgData.data[j + 1] = data[k + 1];
                imgData.data[j + 2] = data[k + 2];
                imgData.data[j + 3] = 255;
                j += 4;
              }
            } else {
              continue;
            }

            ctx.putImageData(imgData, 0, 0);

            const blob = await new Promise((res) => canvas.toBlob(res, "image/png"));
            if (!blob) continue;

            const figFilename = `fig${imageCounter}.png`;
            const file = new File([blob], figFilename, { type: "image/png" });

            const formData = new FormData();
            formData.append("file", file);

            const imgResp = await uploadMediaFn(formData);
            if (imgResp && imgResp.data && imgResp.data.url) {
              const cdnUrl = imgResp.data.url;
              extractedImageUrls.push(cdnUrl);
              imageMap[figFilename] = cdnUrl;
              imageMap[`figure${imageCounter}.png`] = cdnUrl;
              imageMap[`fig${imageCounter}`] = cdnUrl;
              imageMap[`figure${imageCounter}`] = cdnUrl;
              imageCounter++;
            }
          }
        }
      }

      return { extractedImageUrls, imageMap };
    } catch (err) {
      console.error("extractAndUploadPdfImages error:", err);
      return { extractedImageUrls: [], imageMap: {} };
    }
  };

  const parseJatsXml = (xmlData, uploadedImageUrls = []) => {
    if (!xmlData) return null;
    try {
      const xmlString = typeof xmlData === "string" ? xmlData : String(xmlData);
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(xmlString, "text/xml");

      const titleNode =
        xmlDoc.querySelector("article-title") ||
        xmlDoc.querySelector("title-group title") ||
        xmlDoc.querySelector("front title");
      const title = titleNode ? titleNode.textContent.trim() : "";

      let abstract = "";
      const abstractNode = xmlDoc.querySelector("abstract");
      if (abstractNode) {
        const ps = abstractNode.querySelectorAll("p");
        if (ps.length > 0) {
          abstract = Array.from(ps)
            .map((p) => p.textContent.trim())
            .filter(Boolean)
            .join("\n\n");
        } else {
          abstract = abstractNode.textContent.trim();
        }
      }

      const keywords = [];
      const kwdNodes = xmlDoc.querySelectorAll("kwd-group kwd, kwd");
      kwdNodes.forEach((k) => {
        const val = k.textContent.trim();
        const lower = val.toLowerCase();
        if (
          val &&
          lower !== "keywords" &&
          lower !== "keyword" &&
          lower !== "n/a" &&
          lower !== "none" &&
          !keywords.includes(val)
        ) {
          keywords.push(val);
        }
      });
      if (keywords.length === 0) {
        const kwdGroup = xmlDoc.querySelector("kwd-group");
        if (kwdGroup) {
          const rawText = kwdGroup.textContent.replace(/keywords\s*:?/i, "").trim();
          if (rawText) {
            rawText.split(/[,;]/).forEach((item) => {
              const val = item.trim();
              const lower = val.toLowerCase();
              if (
                val &&
                lower !== "keywords" &&
                lower !== "keyword" &&
                lower !== "n/a" &&
                lower !== "none" &&
                !keywords.includes(val)
              ) {
                keywords.push(val);
              }
            });
          }
        }
      }

      const serializer = new XMLSerializer();
      const parseJatsNode = (node) => {
        if (!node) return "";
        if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent;
        }
        if (node.nodeType !== Node.ELEMENT_NODE) {
          return "";
        }
        const tagName = node.tagName.toLowerCase();
        if (tagName === "title" || tagName === "sec") {
          return "";
        } else if (tagName === "bold" || tagName === "b") {
          return `<strong>${Array.from(node.childNodes).map(parseJatsNode).join("")}</strong>`;
        } else if (tagName === "italic" || tagName === "i") {
          return `<em>${Array.from(node.childNodes).map(parseJatsNode).join("")}</em>`;
        } else if (tagName === "sup") {
          return `<sup>${Array.from(node.childNodes).map(parseJatsNode).join("")}</sup>`;
        } else if (tagName === "sub") {
          return `<sub>${Array.from(node.childNodes).map(parseJatsNode).join("")}</sub>`;
        } else if (tagName === "disp-formula" || tagName === "inline-formula") {
          let latex = "";
          const texMath = node.querySelector("tex-math");
          if (texMath) {
            latex = texMath.textContent.trim().replace(/^<!\[CDATA\[/, "").replace(/\]\]>$/, "").trim();
          } else {
            latex = node.textContent.trim();
          }
          if (latex) {
            return tagName === "disp-formula"
              ? `<div class="disp-formula my-3 text-center" style="margin: 16px 0; text-align: center; overflow-x: auto;">\\[ ${latex} \\]</div>`
              : `<span class="inline-formula" style="font-style: italic;">\\( ${latex} \\)</span>`;
          }
          return "";
        } else if (tagName === "tex-math") {
          let latex = node.textContent.trim();
          latex = latex.replace(/^<!\[CDATA\[/, "").replace(/\]\]>$/, "").trim();
          if (latex) {
            return `<div class="disp-formula my-3 text-center" style="margin: 16px 0; text-align: center; font-style: italic; font-size: 1.1rem;">\\[ ${latex} \\]</div>`;
          }
          return "";
        } else if (tagName === "p") {
          let pInner = "";
          if (node.children.length > 0) {
            const childNodes = Array.from(node.childNodes);
            const hasSpecialTag = childNodes.some(
              (c) => c.nodeType === Node.ELEMENT_NODE && ["inline-formula", "disp-formula", "tex-math", "sec", "title", "fig", "graphic", "img", "table", "table-wrap"].includes(c.tagName.toLowerCase())
            );
            if (hasSpecialTag) {
              pInner = childNodes.map((c) => (c.nodeType === Node.ELEMENT_NODE ? parseJatsNode(c) : c.textContent)).join("");
            } else {
              pInner = node.innerHTML || node.textContent.trim();
            }
          } else {
            pInner = node.innerHTML || node.textContent.trim();
          }
          return `<p>${pInner}</p>`;
        } else if (tagName === "table") {
          node.setAttribute("class", "table table-bordered align-middle");
          return `<div class="table-responsive my-3">${serializer.serializeToString(node)}</div>`;
        } else if (tagName === "table-wrap") {
          const tableEl = node.querySelector("table");
          const captionEl = node.querySelector("caption");
          const labelEl = node.querySelector("label");
          let cap = "";
          if (labelEl || captionEl) {
            cap = `<caption style="caption-side: top; font-weight: bold; color: #006f94; margin-bottom: 8px;">${labelEl ? labelEl.textContent.trim() + " " : ""}${captionEl ? captionEl.textContent.trim() : ""}</caption>`;
          }
          if (tableEl) {
            tableEl.setAttribute("class", "table table-bordered align-middle");
            return `<div class="table-responsive my-3"><table class="table table-bordered align-middle">${cap}${tableEl.innerHTML}</table></div>`;
          } else {
            return `<div class="table-responsive my-3">${serializer.serializeToString(node)}</div>`;
          }
        } else if (tagName === "list") {
          const listType = node.getAttribute("list-type");
          const tag = listType === "order" || listType === "decimal" ? "ol" : "ul";
          const items = Array.from(node.querySelectorAll("list-item"))
            .map((li) => `<li>${li.innerHTML || li.textContent.trim()}</li>`)
            .join("");
          return `<${tag}>${items}</${tag}>`;
        } else {
          return serializer.serializeToString(node);
        }
      };

      const sections = [];
      const secNodes =
        xmlDoc.querySelectorAll("body > sec").length > 0
          ? xmlDoc.querySelectorAll("body > sec")
          : xmlDoc.querySelectorAll("sec");

      secNodes.forEach((sec) => {
        const titleEl = sec.querySelector("title");
        const rawSecTitle = titleEl ? titleEl.textContent.trim() : "Section";
        const secTitle = rawSecTitle;

        if (secTitle.toLowerCase() !== "abstract") {
          const secClone = sec.cloneNode(true);
          const cloneTitle = secClone.querySelector("title");
          if (cloneTitle) cloneTitle.remove();

          let contentHtml = Array.from(secClone.childNodes)
            .map(parseJatsNode)
            .join("");

          if (!contentHtml.trim()) {
            const text = secClone.textContent.trim();
            if (text) {
              contentHtml = `<p>${text}</p>`;
            }
          }

          if (contentHtml) {
            sections.push({
              title: secTitle,
              content: contentHtml,
            });
          }
        }
      });

      let references = "";
      const refList = xmlDoc.querySelector("ref-list");
      if (refList) {
        references = refList.innerHTML || refList.textContent.trim();
      }

      let acknowledgements = "";
      const ackNode = xmlDoc.querySelector("ack");
      if (ackNode) {
        acknowledgements = ackNode.innerHTML || ackNode.textContent.trim();
      }

      return {
        title,
        abstract,
        keywords,
        sections,
        acknowledgements,
        references,
      };
    } catch (err) {
      console.error("parseJatsXml error:", err);
      return null;
    }
  };

  const handleUploadArticleSubmit = async () => {
    if (!uploadFile) {
      toast.error("Please select a manuscript document file to upload.");
      return;
    }
    setIsUploadingArticle(true);
    setUploadErrorMessage("");
    try {
      const imageMap = {};
      const uploadedImageUrls = [];
      if (imageList && imageList.length > 0) {
        for (let i = 0; i < imageList.length; i++) {
          const item = imageList[i];
          const formData = new FormData();
          formData.append("file", item.file);
          const imgResp = await UploadMedia(formData);
          if (imgResp && imgResp.data && imgResp.data.url) {
            const key = item.title && item.title.trim() ? item.title.trim() : item.file.name;
            imageMap[key] = imgResp.data.url;
            uploadedImageUrls.push(imgResp.data.url);
          }
        }
      }

      // Upload attached supplementary material (if any)
      const uploadedSupplementaryUrls = [];
      if (supplementaryList && supplementaryList.length > 0) {
        for (let i = 0; i < supplementaryList.length; i++) {
          const item = supplementaryList[i];
          const formData = new FormData();
          formData.append("file", item.file);
          const fname = `${Date.now()}_${item.file.name}`;
          const uploadResp = await UploadMediaWithName(
            formData,
            `?fileName=${fname}`,
          );
          if (uploadResp && uploadResp.data && uploadResp.data.url) {
            uploadedSupplementaryUrls.push(uploadResp.data.url);
          } else {
            console.error("Failed to upload supplementary file:", item.file.name);
          }
        }
      }

      if (uploadFile && (uploadFile.type === "application/pdf" || uploadFile.name.endsWith(".pdf"))) {
        try {
          const pdfExtracted = await extractAndUploadPdfImages(uploadFile, UploadMedia);
          if (pdfExtracted && pdfExtracted.extractedImageUrls && pdfExtracted.extractedImageUrls.length > 0) {
            Object.assign(imageMap, pdfExtracted.imageMap || {});
            pdfExtracted.extractedImageUrls.forEach((url) => {
              if (!uploadedImageUrls.includes(url)) {
                uploadedImageUrls.push(url);
              }
            });
          }
        } catch (pdfErr) {
          console.error("PDF image extraction and upload error:", pdfErr);
        }
      }

      const xmlData = await extractManuscriptXml(uploadFile);

      try {
        sessionStorage.setItem("articleXmlFormat", typeof xmlData === "string" ? xmlData : String(xmlData));
      } catch (e) { }

      const pdfBlob = await generatePdfFromXml(xmlData, imageMap);
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const targetArticleId = articleIdFromUrl || articleDetails?.id || articleDetails?._id;

      try {
        sessionStorage.setItem(`generated_pdf_url_${targetArticleId}`, pdfUrl);
      } catch (e) { }

      const parsed = parseJatsXml(xmlData, uploadedImageUrls);

      let userId = "";
      try {
        const decoded = jwt_decode(localStorage.usertoken);
        userId = decoded?.id || "";
      } catch (e) { }

      const updatedTitle = parsed?.title || articleDetails.title;
      const updatedAbstract = parsed?.abstract || articleDetails.abstract;
      const updatedKeywords = (parsed?.keywords && parsed.keywords.length > 0) ? parsed.keywords : articleDetails.keywords;
      const updatedAck = parsed?.acknowledgements || articleDetails.articleData?.acknowledgement || "";
      const updatedReferences = parsed?.references || articleDetails.articleData?.references || "";
      const updatedSections = (parsed?.sections && parsed.sections.length > 0)
        ? parsed.sections.map((s, idx) => ({ title: s.title, content: s.content, order: idx + 1 }))
        : (articleDetails.articleData?.articleSection || []);
      const finalImages = [...(articleDetails.images || []), ...uploadedImageUrls];

      const payload = {
        userId,
        articleId: targetArticleId,
        title: updatedTitle,
        runningTitle: articleDetails.runningTitle || "",
        abstract: updatedAbstract,
        articleSection: updatedSections,
        keywords: updatedKeywords,
        formulae: articleDetails.formulae || [],
        citations: articleDetails.citations || [],
        abbreviations: articleDetails.abbreviations || [],
        supplymentaryMaterial: Array.from(
          new Set([
            ...(articleDetails.supplymentaryMaterial || []),
            ...uploadedSupplementaryUrls,
          ].filter(Boolean))
        ),
        status: "draft",
        stage: "submit",
        images: finalImages,
        acknowledgement: updatedAck,
        references: updatedReferences,
        articleXmlFormat: typeof xmlData === "string" ? xmlData : String(xmlData),
        documentUploadFailed: false,
      };

      const headersData = { Authorization: `Bearer ${localStorage?.usertoken}` };
      await saveArticleToDraft({ payload, headers: headersData });

      toast.success("Article Review successful!");
      setUploadErrorMessage("");
      setShowUploadArticleModal(false);
      setUploadFile(null);
      setImageList([]);
      setSupplementaryList([]);

      getArticleDetail(targetArticleId);
    } catch (error) {
      console.error("Upload/Extraction error:", error);
      const friendlyMessage = parseExtractorError(error);
      setUploadErrorMessage(friendlyMessage);
      toast.error(friendlyMessage);
    } finally {
      setIsUploadingArticle(false);
    }
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [articleDetails, setarticleDetails] = useState({
    fundingInfo: "",
    authorContributer: "",
    statements: {
      versionOfManuscript: "",
      commercialOrfinancialConflictOfInterest: "",
    },
    id: "",
    abbreviations: [],
    abstract: "",
    articleData: { acknowledgement: "", articleSection: [], references: "" },
    articleViewCount: 0,
    authorDetails: {
      author: [],
      contributionStatement: "",
      notThePrimaryAuthor: false,
    },
    citations: [],
    formulae: [],
    fundingDetails: {
      funder: [],
      fundingInformation: "",
      noFundingRecevied: true,
    },
    images: [],
    keywords: [],
    reviewType: {
      isRecommendReviewers: false,
      paymentDone: false,
      suggestedReviewers: [],
      typeOfReview: "",
    },
    runningTitle: "",
    submissionDetail: {
      articleType: {},
      journalName: "",
      journalType: {},
      societyName: "",
      specialization: {},
      subject: { subjectName: "" },
    },
    supplymentaryMaterial: [],
    title: "",
    masthead: "",
    articleVersion: "Version 1",
  });
  const sucessHandler = (articleData) => {
    if (articleData.status === 200) {
      try {
        const article = articleData.data.data;
        const journalData = articleData?.data?.journalData;
        const articleDetail = articleDetails;
        articleDetail.id = article?._id;
        if (journalData?.masthead) {
          articleDetail.masthead = journalData?.masthead;
        }
        if (article?.fundingDetails?.fundingInformation !== "")
          articleDetail.fundingInfo = article?.fundingDetails?.fundingInformation;
        if (article?.authorDetails?.contributionStatement !== "")
          articleDetail.authorContributer =
            article?.authorDetails?.contributionStatement;
        if (
          article?.statements?.commercial
            ?.commercialOrfinancialConflictOfInterest === "1"
        )
          articleDetail.statements.commercialOrfinancialConflictOfInterest =
            "The authors declare that the research was conducted in the absence of any commercial or financial relationships that could be construed as a potential conflict of interest.";
        else if (
          article?.statements?.commercial
            ?.commercialOrfinancialConflictOfInterest === "2"
        )
          articleDetail.statements.commercialOrfinancialConflictOfInterest =
            article?.statements?.commercial?.text;
        if (article?.statements?.AakashGangaJournal?.versionOfManuscript === "no")
          articleDetail.statements.versionOfManuscript = "";
        else if (
          article?.statements?.AakashGangaJournal?.versionOfManuscript !== "no"
        )
          articleDetail.statements.versionOfManuscript =
            article?.statements?.AakashGangaJournal?.text;
        if (article?.abbreviations)
          articleDetail.abbreviations = article?.abbreviations;
        if (article?.abstract) articleDetail.abstract = article?.abstract;
        if (article?.articleData?.acknowledgement)
          articleDetail.articleData.acknowledgement =
            article?.articleData?.acknowledgement;
        if (article?.articleData?.articleSection)
          articleDetail.articleData.articleSection =
            article?.articleData?.articleSection;
        if (article?.articleData?.references)
          articleDetail.articleData.references = article?.articleData?.references;
        if (article?.articleViewCount)
          articleDetail.articleViewCount = article?.articleViewCount;
        if (article?.authorDetails?.author)
          articleDetail.authorDetails.author = article?.authorDetails.author;
        if (article?.authorDetails?.contributionStatement)
          articleDetail.authorDetails.contributionStatement =
            article?.authorDetails.contributionStatement;
        if (article?.authorDetails?.notThePrimaryAuthor)
          articleDetail.authorDetails.notThePrimaryAuthor =
            article?.authorDetails.notThePrimaryAuthor;
        if (article?.citations) articleDetail.citations = article?.citations;
        if (article?.formulae) articleDetail.formulae = article?.formulae;
        if (article?.fundingDetails?.funder)
          articleDetail.fundingDetails.funder = article?.fundingDetails.funder;
        if (article?.fundingDetails?.fundingInformation)
          articleDetail.fundingDetails.fundingInformation =
            article?.fundingDetails.fundingInformation;
        if (article?.fundingDetails?.noFundingRecevied)
          articleDetail.fundingDetails.noFundingRecevied =
            article?.fundingDetails.noFundingRecevied;
        if (article?.images) articleDetail.images = article?.images;
        if (article?.keywords) articleDetail.keywords = article?.keywords;
        if (article?.reviewType?.isRecommendReviewers)
          articleDetail.reviewType.isRecommendReviewers =
            article?.reviewType.isRecommendReviewers;
        if (article?.reviewType?.paymentDone)
          articleDetail.reviewType.paymentDone = article?.reviewType.paymentDone;
        if (article?.reviewType?.suggestedReviewers)
          articleDetail.reviewType.suggestedReviewers =
            article?.reviewType.suggestedReviewers;
        if (article?.reviewType?.typeOfReview)
          articleDetail.reviewType.typeOfReview =
            article?.reviewType.typeOfReview;
        if (article?.runningTitle)
          articleDetail.runningTitle = article?.runningTitle;
        if (article?.submissionDetail?.articleType)
          articleDetail.submissionDetail.articleType =
            article?.submissionDetail.articleType;
        if (article?.submissionDetail?.journalName)
          articleDetail.submissionDetail.journalName =
            article?.submissionDetail.journalName;
        if (article?.submissionDetail?.journalType)
          articleDetail.submissionDetail.journalType =
            article?.submissionDetail.journalType;
        if (article?.submissionDetail?.societyName)
          articleDetail.submissionDetail.societyName =
            article?.submissionDetail.societyName;
        if (article?.submissionDetail?.specialization)
          articleDetail.submissionDetail.specialization =
            article?.submissionDetail.specialization;
        if (article?.submissionDetail?.subject)
          articleDetail.submissionDetail.subject =
            article?.submissionDetail.subject;
        if (article?.supplymentaryMaterial)
          articleDetail.supplymentaryMaterial = article?.supplymentaryMaterial;
        if (article?.title) articleDetail.title = article?.title;
        if (article?.articleVersion) articleDetail.articleVersion = article?.articleVersion;
        if (article?.journaldstype) articleDetail.journaldstype = article?.journaldstype;
        if (article?.journalType) articleDetail.journalType = article?.journalType;
        setarticleDetails({ ...articleDetail });
      } catch (err) {
        console.error("Error in preview article sucessHandler:", err);
      }
    }
  };
  const { mutate: getArticleById } = FetchArticleById(sucessHandler);

  useEffect(() => {
    const articleID = router.pathname.split("/")[2];
    getArticleDetail(articleID);
  }, []);

  const isSocietyJournal =
    articleDetails?.journaldstype === "societyArticle" ||
    articleDetails?.journalType === "Society Journal" ||
    articleDetails?.journalType === "6454a6390d88e62fa10503bf" ||
    articleDetails?.journalType?._id === "6454a6390d88e62fa10503bf" ||
    articleDetails?.journalType?.journalType === "Society Journal" ||
    articleDetails?.submissionDetail?.journalType?.journalType === "Society Journal" ||
    articleDetails?.submissionDetail?.journalType === "6454a6390d88e62fa10503bf" ||
    articleDetails?.submissionDetail?.journalType?._id === "6454a6390d88e62fa10503bf" ||
    Boolean(articleDetails?.submissionDetail?.societyName);

  const isDataLoaded = Boolean(
    articleDetails?.id ||
    articleDetails?._id ||
    articleDetails?.title ||
    articleDetails?.submissionDetail?.journalName
  );

  const isMegaJournal = isDataLoaded && !isSocietyJournal;

  const handleSaveSection = async (sectionTitle, newContent, sectionIndex) => {
    const articleID = articleIdFromUrl || articleDetails?.id || articleDetails?._id;
    let userId = "";
    try {
      const decoded = jwt_decode(localStorage.usertoken);
      userId = decoded?.id || "";
    } catch (e) { }

    let updatedAbstract = articleDetails.abstract;
    let updatedArticleSections = [...(articleDetails.articleData?.articleSection || [])];
    let updatedAuthorContributer = articleDetails.authorContributer;
    let updatedFundingInfo = articleDetails.fundingInfo;
    let updatedConflictOfInterest = articleDetails.statements?.commercialOrfinancialConflictOfInterest;
    let updatedReferences = articleDetails.articleData?.references || "";
    let updatedAcknowledgement = articleDetails.articleData?.acknowledgement || "";

    const lowerTitle = (sectionTitle || "").toLowerCase().trim();

    if (lowerTitle.includes("abstract")) {
      updatedAbstract = newContent;
      setarticleDetails((prev) => ({ ...prev, abstract: newContent }));
    } else if (lowerTitle.includes("author contribution")) {
      updatedAuthorContributer = newContent;
      setarticleDetails((prev) => ({ ...prev, authorContributer: newContent }));
    } else if (lowerTitle.includes("funding information") || lowerTitle.includes("funding info")) {
      updatedFundingInfo = newContent;
      setarticleDetails((prev) => ({ ...prev, fundingInfo: newContent }));
    } else if (lowerTitle.includes("conflict of interest")) {
      updatedConflictOfInterest = newContent;
      setarticleDetails((prev) => ({
        ...prev,
        statements: { ...prev.statements, commercialOrfinancialConflictOfInterest: newContent },
      }));
    } else if (lowerTitle.includes("reference")) {
      updatedReferences = newContent;
      setarticleDetails((prev) => ({
        ...prev,
        articleData: { ...prev.articleData, references: newContent },
      }));
    } else if (lowerTitle.includes("acknowledgement")) {
      updatedAcknowledgement = newContent;
      setarticleDetails((prev) => ({
        ...prev,
        articleData: { ...prev.articleData, acknowledgement: newContent },
      }));
    } else if (typeof sectionIndex === "number" && updatedArticleSections[sectionIndex]) {
      updatedArticleSections[sectionIndex] = {
        ...updatedArticleSections[sectionIndex],
        content: newContent,
      };
      setarticleDetails((prev) => ({
        ...prev,
        articleData: { ...prev.articleData, articleSection: updatedArticleSections },
      }));
    } else {
      const secIdx = updatedArticleSections.findIndex(
        (sec) => (sec.title || "").toLowerCase().trim() === lowerTitle
      );
      if (secIdx !== -1) {
        updatedArticleSections[secIdx] = {
          ...updatedArticleSections[secIdx],
          content: newContent,
        };
        setarticleDetails((prev) => ({
          ...prev,
          articleData: { ...prev.articleData, articleSection: updatedArticleSections },
        }));
      }
    }

    let currentVerNum = 1;
    if (articleDetails?.articleVersion) {
      const match = String(articleDetails.articleVersion).match(/\d+/);
      if (match) {
        currentVerNum = parseInt(match[0], 10);
      }
    }
    const nextVerNum = currentVerNum + 1;
    const newArticleVersion = `Version ${nextVerNum}`;

    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const payload = {
      userId: userId,
      articleId: articleID,
      title: articleDetails.title,
      abstract: updatedAbstract,
      articleSection: updatedArticleSections,
      acknowledgement: updatedAcknowledgement,
      references: updatedReferences,
      authorContributer: updatedAuthorContributer,
      fundingInfo: updatedFundingInfo,
      articleVersion: newArticleVersion,
      status: articleDetails.status || "draft",
      stage: articleDetails.stage || "draft",
    };

    try {
      await saveArticleToDraft({ payload, headers });
      setarticleDetails((prev) => ({
        ...prev,
        articleVersion: newArticleVersion,
      }));
      toast.success(`Section updated successfully and saved as ${newArticleVersion}!`);
    } catch (err) {
      console.error("Save section error:", err);
      toast.error("Failed to save section edits. Please try again.");
      throw err;
    }
  };

  const handleFinalSubmit = async (extraPayloadFields = {}, options = {}) => {
    const articleID = articleIdFromUrl || articleDetails?.id || articleDetails?._id;
    let userId = "";
    try {
      const decoded = jwt_decode(localStorage.usertoken);
      userId = decoded?.id || "";
    } catch (e) { }

    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const payload = {
      userId: userId,
      articleId: articleID,
      status: "submit",
      stage: "submitted",
      journaldstype: "",
      ...extraPayloadFields
    };

    setIsSubmitting(true);
    try {
      await saveArticleToDraft({ payload, headers });
      if (options.showPendingModalFirst) {
        setShowProfanityPendingModal(true);
      } else {
        setShowSubmitSuccessModal(true);
      }
    } catch (err) {
      console.error("Submission error:", err);
      toast.error("Failed to submit article. Please try again.");
      try {
        await notifySubmissionFailure({
          headers,
          payload: {
            userId: userId,
            articleId: articleID,
            title: articleDetails?.title,
            journalName: articleDetails?.submissionDetail?.journalName,
            reason: err?.message || "Failed to submit article due to a system error. Please try again."
          }
        });
      } catch (notifyErr) {
        console.error("Failed to trigger submission failure notification:", notifyErr);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  async function getArticleDetail(id) {
    //
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    const queryParams = {
      params: { articleId: id },
      headers: headers,
    };

    getArticleById(queryParams);
  }
  const [collapseActive, setIsActive] = useState(false);

  const [historyResult, setHistoryResult] = useState(false);
  const navigate = useNavigate();
  const [imageDownload, setimageDownload] = useState(false);
  const [isPreviewMode, setIsPreviewMode] = useState(false);

  const [profanityWords, setProfanityWords] = useState([]);
  const [profanityMatches, setProfanityMatches] = useState([]);
  const [showProfinityAl, setShowProfinityAl] = useState(false);
  const [showProfanityResultModal, setShowProfanityResultModal] = useState(false);
  const [showProfanityPendingModal, setShowProfanityPendingModal] = useState(false);
  const [profanityWordsFoundModal, setProfanityWordsFoundModal] = useState([]);
  const [profanityMatchesFoundModal, setProfanityMatchesFoundModal] = useState([]);

  const currentProfanityWordsForDetails = !isMegaJournal ? profanityWords : (profanityWordsFoundModal.length > 0 ? profanityWords : []);

  const sucessHandlerProfanity = (profanity) => {
    if (profanity.status === 200 && Array.isArray(profanity.data?.data)) {
      setProfanityWords(profanity.data.data);
    }
  };
  const { mutate: getProfanityList } = FetchProfanityList(sucessHandlerProfanity);

  useEffect(() => {
    const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
    getProfanityList({ headers });
  }, []);

  const isExactMatchProfanity = (str, match) => {
    if (!str || !match) return false;
    const safeMatch = match.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    return new RegExp(`\\b${safeMatch}\\b`, "gi").test(str);
  };

  const handleSubmitArticleClick = async () => {
    let currentProfanityList = profanityWords;
    if (!currentProfanityList || currentProfanityList.length === 0) {
      try {
        const headers = { Authorization: `Bearer ${localStorage?.usertoken}` };
        const res = await axios.get(`${SERVER_URL}/AakashGanga/getProfanityWords`, { headers });
        if (res?.data?.data && Array.isArray(res.data.data)) {
          currentProfanityList = res.data.data;
          setProfanityWords(currentProfanityList);
        }
      } catch (e) {
        console.error("Error fetching profanity list fallback:", e);
      }
    }

    const sectionMatches = [];
    if (currentProfanityList && currentProfanityList.length > 0) {
      const checkSec = (title, content) => {
        if (!content || typeof content !== "string") return;
        const cleanText = content.replace(/(<([^>]+)>)/gi, "");
        const foundInSec = [];
        currentProfanityList.forEach((word) => {
          if (word && isExactMatchProfanity(cleanText, word)) {
            if (!foundInSec.includes(word)) foundInSec.push(word);
          }
        });
        if (foundInSec.length > 0) {
          const cleanedTitle = title.replace(/^\s*(?:\d+(?:\.\d+)*\s*[\.\-\:]\s*|\d+\s+(?=[A-Za-z])|\(\d+\)\s*)/i, '').trim();
          sectionMatches.push({
            title: cleanedTitle || title,
            id: `viewScroll${cleanedTitle || title}`,
            words: foundInSec,
          });
        }
      };

      checkSec("Abstract", articleDetails.abstract);
      (articleDetails?.articleData?.articleSection || []).forEach((sec, idx) => {
        checkSec(sec.title || `Section ${idx + 1}`, sec.content);
      });
      checkSec("Author Contributions", articleDetails.authorContributer);
      checkSec("Funding Information", articleDetails.fundingInfo);
      checkSec("Conflict of Interest", articleDetails?.statements?.commercialOrfinancialConflictOfInterest);
      checkSec("Acknowledgements", articleDetails?.articleData?.acknowledgement);
    }

    if (sectionMatches.length > 0) {
      const allWords = Array.from(new Set(sectionMatches.flatMap((m) => m.words)));
      setProfanityMatches(sectionMatches);
      setProfanityMatchesFoundModal(sectionMatches);
      setProfanityWordsFoundModal(allWords);
      setShowProfinityAl(true);
      setShowProfanityResultModal(true);
      return;
    }

    setShowProfinityAl(false);
    await handleFinalSubmit();
  };

  const handleFlagArticleToAdmin = async () => {
    setShowProfanityResultModal(false);
    const flagPayload = {
      isFlaggedToUs: true,
      isProfaneFlagged: true,
      profanityWordsPresent: {
        isPresent: true,
        words: profanityWordsFoundModal,
        isFlaggedToUs: true,
      }
    };
    await handleFinalSubmit(flagPayload, { showPendingModalFirst: true });
  };

  useEffect(() => {
    if (!profanityWords || profanityWords.length === 0) return;
    const matches = [];

    const checkSec = (title, content) => {
      if (!content || typeof content !== "string") return;
      const cleanText = content.replace(/(<([^>]+)>)/gi, "");
      const foundInSec = [];
      profanityWords.forEach((word) => {
        if (word && isExactMatchProfanity(cleanText, word)) {
          if (!foundInSec.includes(word)) foundInSec.push(word);
        }
      });
      if (foundInSec.length > 0) {
        const cleanedTitle = title.replace(/^\s*(?:\d+(?:\.\d+)*\s*[\.\-\:]\s*|\d+\s+(?=[A-Za-z])|\(\d+\)\s*)/i, '').trim();
        matches.push({
          title: cleanedTitle || title,
          id: `viewScroll${cleanedTitle || title}`,
          words: foundInSec,
        });
      }
    };

    checkSec("Abstract", articleDetails.abstract);
    (articleDetails?.articleData?.articleSection || []).forEach((sec, idx) => {
      checkSec(sec.title || `Section ${idx + 1}`, sec.content);
    });
    checkSec("Author Contributions", articleDetails.authorContributer);
    checkSec("Funding Information", articleDetails.fundingInfo);
    checkSec("Conflict of Interest", articleDetails?.statements?.commercialOrfinancialConflictOfInterest);

    setProfanityMatches(matches);
  }, [articleDetails, profanityWords]);

  function getAuthors() {
    let authors = [];
    if (articleDetails.authorDetails.author) {
      authors = articleDetails.authorDetails.author;
    }
    return authors;
  }
  const handleClick2 = (event) => {
    const target = event.target;
    if (target && target.tagName && target.tagName.toLowerCase() === "a") {
      const hrefAttr = target.getAttribute("href");
      if (hrefAttr && hrefAttr.startsWith("#")) {
        const hrefValue = hrefAttr.substring(1);
        const targetElement = document.getElementById(hrefValue);
        if (targetElement && targetElement.parentNode && targetElement.parentNode.parentNode) {
          targetElement.parentNode.parentNode.classList.add("dshighlight");
          setTimeout(() => {
            targetElement.parentNode.parentNode.classList.remove("dshighlight");
          }, 3000);
        }
      }
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClick2);
    //     });
    // };
  }, []);
  const stripLeadingHeadingNumber = (title) => {
    if (!title || typeof title !== "string") return title;
    return title.replace(/^\s*(?:\d+(?:\.\d+)*\s*[\.\-\:]\s*|\d+\s+(?=[A-Za-z])|\(\d+\)\s*)/i, "").trim();
  };

  function getTableOfContent() {
    let content = ["Abstract"];
    const regex = /(<([^>]+)>)/gi;

    const sections = articleDetails?.articleData?.articleSection || [];
    if (Array.isArray(sections) && sections.length > 0) {
      sections.forEach((article) => {
        const textContent = article?.content || "";
        let images = textContent ? textContent.match(/<img\s+[^>]*src="([^"]*)"[^>]*>/i) : null;
        if ((textContent && textContent.replace(regex, "") !== "") || images)
          content.push(stripLeadingHeadingNumber(article?.title || ""));
      });
    }

    const ack = articleDetails?.articleData?.acknowledgement || "";
    let akimages = ack ? ack.match(/<img\s+[^>]*src="([^"]*)"[^>]*>/i) : null;
    if ((ack && ack.replace(regex, "") !== "") || akimages)
      content.push("Acknowledgements");

    const refs = articleDetails?.articleData?.references || "";
    if (refs && refs.replace(regex, "") !== "")
      content.push("References");

    return content;
  }
  function getNameFromUrl(url) {
    let name = "";
    const pieces = url.split(/[\s/]+/);
    const last = pieces[pieces.length - 1];
    if (last) {
      const dtl = last.split("_");
      if (dtl[1]) name = dtl[1].replace(/%20/g, " ");
      else name = last.replace(/%20/g, " ");
    }

    return name;
  }

  return (
    <>
      <div className="inner-pages">
        <div className="centerSection">
          <div className="previewPageWrap w-100">
            <div
              className="previewHero"
              style={{
                backgroundImage: `url()`,
                backgroundSize: `100%`,
              }}
            >
              <img
                src={articleDetails?.masthead ? articleDetails?.masthead : src}
                style={{ width: `100%` }}
              />
            </div>

            <div className="previewTags">
              <ViewHeaderLink
                pagename="previewArticle"
                details={{
                  first: "",
                  second: articleDetails.submissionDetail.societyName,
                  fourth:
                    articleDetails.submissionDetail.articleType.articleName,
                }}
              />
            </div>

            <div className="publiseTitle">
              <div className="innerMergin">{articleDetails.title}</div>
            </div>
            <Authors pagename="previewArticle" details={getAuthors()} />
            {isMegaJournal && (
              <div className="innerMergin" style={{ marginTop: "6px", marginBottom: "6px" }}>
                <p style={{ fontStyle: "italic", color: "#4a5568", fontSize: "18px", margin: 0 }}>
                  This is a preview of the submitted article. When published, this is how your article will appear
                </p>
              </div>
            )}
            <PublishedDate pagename="previewArticle" details={articleDetails} onSubmitArticle={handleSubmitArticleClick} />

            {profanityMatches.length > 0 && showProfinityAl && (
              <div className="profinatyWordAlways">
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <div>
                    <h3>Profanity Check Results</h3>
                    <small style={{ fontSize: "12px", color: "#666" }}>
                      Please click on titles below to correct that section
                    </small>
                  </div>
                  <button
                    onClick={() => setShowProfinityAl(false)}
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                  ></button>
                </div>
                <ol style={{ paddingLeft: "18px", margin: 0 }}>
                  {profanityMatches.map((item, idx) => (
                    <React.Fragment key={idx}>
                      <li
                        className="pt-2"
                        style={{ cursor: "pointer", fontWeight: "bold" }}
                        onClick={() => {
                          const el = document.getElementById(item.id);
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth", block: "center" });
                          }
                        }}
                      >
                        <span style={{ color: "#009b94", textDecoration: "underline", cursor: "pointer" }}>
                          {item.title}
                        </span>
                      </li>
                      <ul className="ps-3 d-flex flex-wrap gap-2 mb-1">
                        {item.words.map((w, wIdx) => (
                          <li key={wIdx} style={{ color: "red", fontWeight: "bold" }}>
                            {w}
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  ))}
                </ol>
              </div>
            )}

            <div className="publisActionWrap">
              <div className="innerMergin">
                <ArticleLinks
                  pagename="previewArticle"
                  details=""
                  journalName={articleDetails?.submissionDetail?.journalName}
                />
              </div>
            </div>
            <div className="previewMain">
              <div className="innerMergin">
                <div className="row">
                  <div className="col-md-4">
                    <div className="mt-3">
                      <TableOfContent
                        pagename="previewArticle"
                        details={getTableOfContent()}
                      />

                      {articleDetails.keywords.length > 0 && (
                        <div className="keyBox previewKey commanBox">
                          <span class="tagTitle">Keyword</span>
                          <div className="previewKeyArea">
                            {articleDetails.keywords.map((keyword, index) => (
                              <span key={keyword} className="t-tag">
                                {keyword}
                              </span>
                            ))}
                          </div>
                        </div>
                      )}
                      {articleDetails.abbreviations.length > 0 && (
                        <div className=" commanBox abbreviations mb-4 d-inline-block w-100">
                          <span class="tagTitle">Abbreviations</span>
                          {articleDetails.abbreviations.map(
                            (abbreviation, index) => (
                              <span
                                key={abbreviation}
                                className="t-tag abbreView"
                              >
                                <b>{abbreviation.apprv}</b>
                                <b>{abbreviation.fullForm}</b>
                              </span>
                            )
                          )}
                        </div>
                      )}
                      {(() => {
                        const allImages = [];

                        // 1. Add direct image URLs from articleDetails.images
                        if (Array.isArray(articleDetails?.images)) {
                          articleDetails.images.forEach(img => {
                            if (img && typeof img === 'string') {
                              const clean = img.trim();
                              if (clean && !allImages.includes(clean)) allImages.push(clean);
                            }
                          });
                        }

                        // 2. Extract embedded images from abstract, sections, acknowledgement
                        const contentSources = [
                          articleDetails?.abstract,
                          ...(articleDetails?.articleData?.articleSection || []).map(s => s?.content || ''),
                          articleDetails?.articleData?.acknowledgement || '',
                        ];
                        contentSources.forEach(html => {
                          if (html && typeof html === 'string') {
                            const found = extractImagesFromHtml(html, articleDetails?.images || []);
                            found.forEach(url => {
                              if (url && typeof url === 'string') {
                                const clean = url.trim();
                                if (clean && !allImages.includes(clean)) allImages.push(clean);
                              }
                            });
                          }
                        });

                        // 3. Fallback: check localStorage for images
                        try {
                          const localData = localStorage.getItem("submitArticleData") || localStorage.getItem("articleData");
                          if (localData) {
                            const parsed = JSON.parse(localData);
                            if (parsed?.images && Array.isArray(parsed.images)) {
                              parsed.images.forEach(img => {
                                if (img && typeof img === 'string') {
                                  const clean = img.trim();
                                  if (clean && !allImages.includes(clean)) allImages.push(clean);
                                }
                              });
                            }
                          }
                        } catch (e) { }

                        if (allImages.length === 0) return null;

                        return (
                          <div className="commanBox mb-25">
                            <span className="tagTitle">
                              Images and Figures
                              <div className="customTool">
                                {["bottom"].map((placement) => (
                                  <OverlayTrigger
                                    key={placement}
                                    placement={placement}
                                    overlay={
                                      <Popover>
                                        <Popover.Body>
                                          <div className="popoverToolWrap">
                                            <p>
                                              We require figures to be submitted
                                              individually, in the same order as
                                              they are presented in the
                                              manuscript. Kindly ensure that each
                                              table and figure is mentioned in the
                                              text and in numerical order.
                                            </p>
                                          </div>
                                        </Popover.Body>
                                      </Popover>
                                    }
                                  >
                                    <img
                                      className="pe-cursor ps-1"
                                      src={active_info}
                                      alt="no img"
                                    />
                                  </OverlayTrigger>
                                ))}
                              </div>
                            </span>
                            <div className="imgShowBox">
                              {allImages.map((src, index) => (
                                <b
                                  key={`img-${index}`}
                                  style={{
                                    backgroundImage: `url("${src}")`,
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                    backgroundRepeat: 'no-repeat',
                                    display: 'inline-block',
                                    width: '102px',
                                    height: '80px',
                                    marginRight: '15px',
                                    marginBottom: '15px',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    backgroundColor: '#f8fafc',
                                    border: '1px solid #e2e8f0',
                                    verticalAlign: 'top',
                                  }}
                                >
                                  <img
                                    src={src}
                                    alt={`Figure ${index + 1}`}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'contain',
                                      display: 'block'
                                    }}
                                    onError={(e) => {
                                      // If img fails to load directly, keep background-image fallback or hide broken icon
                                      e.target.style.opacity = '0';
                                    }}
                                  />
                                </b>
                              ))}
                            </div>
                          </div>
                        );
                      })()}
                      {articleDetails.supplymentaryMaterial.length > 0 && (
                        <div className="commanBox mb-25">
                          <span className="tagTitle">
                            Supplementary Material{" "}
                            <div className="customTool">
                              {["bottom"].map((placement) => (
                                <OverlayTrigger
                                  key={placement}
                                  placement={placement}
                                  overlay={
                                    <Popover>
                                      <Popover.Body>
                                        <div className="popoverToolWrap">
                                          <p>
                                            Please note that supplementary
                                            material is not typeset. Kindly
                                            ensure that all information is
                                            clearly presented.
                                          </p>
                                          <br />
                                          <p>
                                            1. Please use a simple file name
                                            with formate .pdf, .doc, .docx,
                                            .xlsx, .pptx or .rtf.
                                          </p>
                                          <p>
                                            2. Add appropriate caption in the
                                            supplementary file including all
                                            highlights, line numbers.
                                          </p>
                                          <p>
                                            3. Remove all the track changes and
                                            ensure that the style conforms to
                                            the rest of the article.
                                          </p>
                                        </div>
                                      </Popover.Body>
                                    </Popover>
                                  }
                                >
                                  <img
                                    className="pe-cursor ps-1"
                                    src={active_info}
                                    alt="no img"
                                  />
                                </OverlayTrigger>
                              ))}
                            </div>{" "}
                          </span>

                          {articleDetails.supplymentaryMaterial.map(
                            (img, index) => (
                              <div
                                className="docShowBox supplimentPreview"
                                key={`mat${index}`}
                              >
                                <div className="docShowList">
                                  <a>
                                    <span>{getNameFromUrl(img)}</span>
                                  </a>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      )}
                      <LeftCommonLink
                        pagename="previewArticle"
                        details={{
                          img: infoI,
                          text: "Information, Rights and Permissions",
                          type: "Information",
                        }}
                      />
                      <LeftCommonLink
                        pagename="previewArticle"
                        details={{
                          img: copyC,
                          text: "Copyright and License",
                          type: "Copyright",
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="publiceUiBox ">
                      <div className="publiceDetailsWrap"></div>
                      <div className="previewBox previewBox se-wrapper-inner">
                        <ContentDetails
                          key={`abstract-${isPreviewMode}-${isMegaJournal}`}
                          pagename="previewArticle"
                          details={{
                            title: "Abstract",
                            desc: articleDetails.abstract,
                          }}
                          isEditable={isMegaJournal && !isPreviewMode}
                          onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                          defaultEditing={isMegaJournal && !isPreviewMode}
                          articleImages={articleDetails.images}
                          profanityWords={currentProfanityWordsForDetails}
                        />
                        {(articleDetails?.articleData?.articleSection || []).map(
                          (article, index) => (
                            <React.Fragment key={`sec-${index}-${isPreviewMode}-${isMegaJournal}`}>
                              {(isMegaJournal || checkEmptyArticle(article?.content) !== "") && (
                                <ContentDetails
                                  pagename="previewArticle"
                                  details={{
                                    title: article?.title || `Section ${index + 1}`,
                                    desc: article?.content || "",
                                  }}
                                  isEditable={isMegaJournal && !isPreviewMode}
                                  onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                                  sectionIndex={index}
                                  defaultEditing={isMegaJournal && !isPreviewMode}
                                  articleImages={articleDetails.images}
                                  profanityWords={currentProfanityWordsForDetails}
                                />
                              )}
                            </React.Fragment>
                          )
                        )}
                        {(isMegaJournal || checkEmptyArticle(articleDetails?.authorContributer) !== "") && (
                          <ContentDetails
                            key={`authorContrib-${isPreviewMode}-${isMegaJournal}`}
                            pagename="previewArticle"
                            details={{
                              title: "Author Contributions",
                              desc: articleDetails?.authorContributer || "",
                            }}
                            isEditable={isMegaJournal && !isPreviewMode}
                            onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                            defaultEditing={isMegaJournal && !isPreviewMode}
                            articleImages={articleDetails.images}
                            profanityWords={currentProfanityWordsForDetails}
                          />
                        )}
                        {(isMegaJournal || checkEmptyArticle(articleDetails?.fundingInfo) !== "") && (
                          <ContentDetails
                            key={`funding-${isPreviewMode}-${isMegaJournal}`}
                            pagename="previewArticle"
                            details={{
                              title: "Funding Information",
                              desc: articleDetails?.fundingInfo || "",
                            }}
                            isEditable={isMegaJournal && !isPreviewMode}
                            onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                            defaultEditing={isMegaJournal && !isPreviewMode}
                            articleImages={articleDetails.images}
                            profanityWords={currentProfanityWordsForDetails}
                          />
                        )}
                        {(isMegaJournal || checkEmptyArticle(articleDetails?.statements?.commercialOrfinancialConflictOfInterest) !== "") && (
                          <ContentDetails
                            key={`conflict-${isPreviewMode}-${isMegaJournal}`}
                            pagename="previewArticle"
                            details={{
                              title: "Conflict of Interest",
                              desc: articleDetails?.statements?.commercialOrfinancialConflictOfInterest || "",
                            }}
                            isEditable={isMegaJournal && !isPreviewMode}
                            onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                            defaultEditing={isMegaJournal && !isPreviewMode}
                            articleImages={articleDetails.images}
                            profanityWords={currentProfanityWordsForDetails}
                          />
                        )}
                        {(isMegaJournal || checkEmptyArticle(articleDetails?.articleData?.references) !== "") && (
                          <ContentDetails
                            key={`references-${isPreviewMode}-${isMegaJournal}`}
                            pagename="previewArticle"
                            details={{
                              title: "References",
                              desc: articleDetails?.articleData?.references || "",
                            }}
                            isEditable={isMegaJournal && !isPreviewMode}
                            onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                            defaultEditing={isMegaJournal && !isPreviewMode}
                            articleImages={articleDetails.images}
                            profanityWords={[]}
                          />
                        )}
                        {(isMegaJournal || checkEmptyArticle(articleDetails?.articleData?.acknowledgement) !== "") && (
                          <ContentDetails
                            key={`acknowledgements-${isPreviewMode}-${isMegaJournal}`}
                            pagename="previewArticle"
                            details={{
                              title: "Acknowledgements",
                              desc: articleDetails?.articleData?.acknowledgement || "",
                            }}
                            isEditable={isMegaJournal && !isPreviewMode}
                            onSaveSection={isMegaJournal && !isPreviewMode ? handleSaveSection : undefined}
                            defaultEditing={isMegaJournal && !isPreviewMode}
                            articleImages={articleDetails.images}
                            profanityWords={currentProfanityWordsForDetails}
                          />
                        )}
                      </div>
                      <div style={{ display: "flex", alignItems: "center", gap: "16px", marginTop: "40px", marginBottom: "20px", flexWrap: "wrap" }}>
                        {isMegaJournal && !isPreviewMode && (
                          <>
                            <button
                              type="button"
                              onClick={() => { setIsPreviewMode(true); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "12px 24px",
                                backgroundColor: "#e87a28",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "6px",
                                fontWeight: "700",
                                fontSize: "14px",
                                cursor: "pointer",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                                textTransform: "uppercase"
                              }}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                <circle cx="12" cy="12" r="3" />
                              </svg>
                              Article Preview
                            </button>
                          </>
                        )}
                        {isMegaJournal && isPreviewMode && (
                          <>
                            <button
                              type="button"
                              className="button button-primary"
                              style={{
                                backgroundColor: "#006f94",
                                borderColor: "#006f94",
                                color: "#ffffff",
                                padding: "12px 36px",
                                fontSize: "15px",
                                fontWeight: "700",
                                borderRadius: "6px",
                                cursor: "pointer",
                                textTransform: "uppercase"
                              }}
                              onClick={handleSubmitArticleClick}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? "SUBMITTING..." : "SUBMIT ARTICLE"}
                            </button>
                            <button
                              type="button"
                              onClick={() => { setIsPreviewMode(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                padding: "12px 24px",
                                backgroundColor: "#006f94",
                                color: "#ffffff",
                                border: "none",
                                borderRadius: "6px",
                                fontWeight: "700",
                                fontSize: "14px",
                                cursor: "pointer",
                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                                textTransform: "uppercase"
                              }}
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                              </svg>
                              ← Back To Editing
                            </button>
                          </>
                        )}
                        {isMegaJournal && !isPreviewMode && (
                          <Link
                            to={`/dashboard/edit-article/${articleIdFromUrl}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "12px 24px",
                              backgroundColor: "#006f94",
                              color: "#ffffff",
                              border: "none",
                              borderRadius: "6px",
                              fontWeight: "700",
                              fontSize: "14px",
                              textDecoration: "none",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap"
                            }}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="19" y1="12" x2="5" y2="12"></line>
                              <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                            BACK TO SUBMISSION FLOW
                          </Link>
                        )}
                        {!isMegaJournal && (
                          <Link
                            to={`/dashboard/edit-article/${articleIdFromUrl}`}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "8px",
                              padding: "12px 24px",
                              backgroundColor: "#009b94",
                              color: "#ffffff",
                              border: "none",
                              borderRadius: "6px",
                              fontWeight: "600",
                              fontSize: "14px",
                              textDecoration: "none",
                              boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
                              textTransform: "uppercase",
                              whiteSpace: "nowrap"
                            }}
                          >
                            ← Back To Article Editor
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={historyResult}
        size="md md-x"
        id="unicheck-results__modal"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered authorModal"
        className="md-x"
      >
        <Modal.Header>
          <h5 className="modal-title pr-color">how to cite this article</h5>
          <button
            type="button"
            className="btn-close"
            onClick={(e) => setHistoryResult(false)}
            aria-label="Close"
          />
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          <div className="citeModalWrap">
            <div className="citeText">
              [ Ayoubi R, Fotouhi M, Southern K et al. The identification of
              high antibodies for Vacuolar protein sorting-associated protein 35
              (hVPS35) for use in Western Blot, immunoprecipitation and
              immunofluorescence [version 1; peer review: awaiting peer review].
              Aakashganga 2023, 12:452
              (https://doi.org/10.12688/Aakashganga.133696.1) ]
            </div>

            <div className="questionBox">
              <span>
                It is important to ensure the information in square brackets
                after the title is included in all citations of this article.
              </span>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer pb-3">
          <button
            className="button-link"
            onClick={(e) => handleRedirect(e, "/myArticle/submit")}
          >
            <img src={copy} alt="#" /> Copy Citation Details
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={imageDownload}
        size="lg"
        id="unicheck-results__modal"
        tabIndex={-1}
        dialogClassName="modal-dialog-centered authorModal"
      >
        <Modal.Header className="imgDownloadHeader">
          <h5>Figure 1</h5>
          <div className="imgDownloadBtn">
            <button
              type="button"
              className="btn-close"
              onClick={(e) => setimageDownload(false)}
            >
              close
            </button>
            <span className="button-link">download image</span>
          </div>
        </Modal.Header>
        <Modal.Body className="pt-0 pb-2">
          <div className="imageDownloadWrap">
            <figure>
              <img src={downloadImg} alt="#" />
            </figure>
            <span>
              CT images of spondyloptosis at various anatomical levels of spine
            </span>
            <p>
              Embryology in development of the caudal region. Drawing of a
              16-day embryo (left) shows the primitive streak, which is a
              longitudinal ridge of ectodermal cells at the caudal end of the
              bilaminar embryonic disc. Drawing of a 20-day embryo (middle)
              demonstrates that primitive regression. Embryology in development
              of the caudal region.
            </p>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showSubmitSuccessModal}
        centered
        className="authorModal md-x"
        onHide={() => {
          setShowSubmitSuccessModal(false);
          localStorage.setItem("dropdownToggleVal", "Author");
          window.location.href = "/dashboard";
        }}
      >
        <Modal.Header closeButton style={{ backgroundColor: "#006f94", color: "#ffffff" }}>
          <h5 className="modal-title mb-0" style={{ color: "#ffffff", fontWeight: "700" }}>
            Congratulations!
          </h5>
        </Modal.Header>
        <Modal.Body className="p-4 text-start">
          <p style={{ fontSize: "15px", color: "#374151", lineHeight: "1.6", margin: "10px 0", textAlign: "left" }}>
            Your document has been accepted and is being sent for editorial assessment. You can track the article’s progress on the Author Dashboard.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0 pb-4">
          <button
            className="button button-primary"
            style={{
              backgroundColor: "#006f94",
              borderColor: "#006f94",
              padding: "10px 32px",
              fontWeight: "700",
              borderRadius: "6px"
            }}
            onClick={() => {
              setShowSubmitSuccessModal(false);
              localStorage.setItem("dropdownToggleVal", "Author");
              window.location.href = "/dashboard";
            }}
          >
            Go to Author Dashboard
          </button>
        </Modal.Footer>
      </Modal>

      {/* Profanity Check Result Modal for Submit Article */}
      <Modal
        show={showProfanityResultModal}
        onHide={() => setShowProfanityResultModal(false)}
        centered
        className="authorModal md-x"
        id="congratsMobile"
      >
        <Modal.Header className="modal-header">
          <div className="modal-icon">
            <img src={alertSearch} alt="Profanity Check" />
          </div>
          <h5 className="modal-title">
            PROFANITY Check Results
          </h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShowProfanityResultModal(false)}
          ></button>
        </Modal.Header>
        <Modal.Body className="pb-0 pt-0 pl-2 pr-2">
          <div className="grantDetails alertPopup">
            <div className="checkResultText">
              <strong>Thank you for submitting your research article.</strong>
              <p>
                Our system has flagged certain terms that may require review.
                These words can be sensitive depending on context.
              </p>
              <p>
                If these terms are used in a valid academic or clinical context,
                you may proceed. Otherwise, please revise as appropriate.
              </p>
            </div>

            <div className="offensiveBox" style={{ maxHeight: "250px", overflowY: "auto" }}>
              {profanityMatchesFoundModal.length > 0 ? (
                <ol style={{ paddingLeft: "18px", margin: 0 }}>
                  {profanityMatchesFoundModal.map((item, idx) => (
                    <React.Fragment key={idx}>
                      <li
                        className="pt-2"
                        style={{ cursor: "pointer", fontWeight: "bold" }}
                        onClick={() => {
                          setShowProfanityResultModal(false);
                          setIsPreviewMode(false);
                          setShowProfinityAl(true);
                          setTimeout(() => {
                            const el = document.getElementById(item.id) || document.getElementById(`viewScroll${item.title}`);
                            if (el) {
                              el.scrollIntoView({ behavior: "smooth", block: "center" });
                            }
                          }, 300);
                        }}
                      >
                        <span style={{ color: "#009b94", textDecoration: "underline", cursor: "pointer" }}>
                          {item.title}
                        </span>
                      </li>
                      <ul className="ps-3 d-flex flex-wrap gap-2 mb-1" style={{ listStyleType: "disc" }}>
                        {item.words.map((w, wIdx) => (
                          <li key={wIdx} style={{ color: "red", fontWeight: "bold" }}>
                            {w}
                          </li>
                        ))}
                      </ul>
                    </React.Fragment>
                  ))}
                </ol>
              ) : (
                <ol>
                  {profanityWordsFoundModal.map((wrd, index) => (
                    <li key={index} style={{ color: "#dc3545", fontWeight: "600" }}>{wrd}</li>
                  ))}
                </ol>
              )}
            </div>

            <div className="mt-4 mb-3 d-flex justify-content-center gap-2">
              <button
                className="button button-primary"
                type="button"
                style={{ backgroundColor: "#006f94", borderColor: "#006f94", color: "#ffffff", padding: "8px 20px" }}
                onClick={() => {
                  setShowProfanityResultModal(false);
                  setIsPreviewMode(false);
                  setShowProfinityAl(true);
                  window.scrollTo({ top: 300, behavior: 'smooth' });
                }}
              >
                Make Amendment
              </button>
              {isSocietyJournal ? (
                <button
                  className="button button-primary"
                  type="button"
                  style={{ backgroundColor: "#006f94", borderColor: "#006f94", color: "#ffffff", padding: "8px 20px" }}
                  onClick={() => {
                    setShowProfanityResultModal(false);
                    const articleID = articleIdFromUrl || articleDetails?.id || articleDetails?._id;
                    if (articleID) {
                      window.location.href = `/dashboard/edit-article/${articleID}`;
                    }
                  }}
                >
                  Article Editor
                </button>
              ) : (
                <button
                  className="button button-primary"
                  type="button"
                  style={{ backgroundColor: "#006f94", borderColor: "#006f94", color: "#ffffff", padding: "8px 20px" }}
                  onClick={() => {
                    setShowProfanityResultModal(false);
                    setShowUploadArticleModal(true);
                  }}
                >
                  Reupload Article
                </button>
              )}
            </div>

            <div>
              <p className="text-center mb-1">Having trouble moving forward?</p>
              <p
                className="fs-5 fw-bold text-center text-danger pe-cursor"
                style={{ cursor: "pointer", textDecoration: "underline" }}
                onClick={handleFlagArticleToAdmin}
              >
                Flag it to us
              </p>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* 1st Modal: Profanity Check Pending Modal */}
      <Modal
        show={showProfanityPendingModal}
        onHide={() => {
          setShowProfanityPendingModal(false);
          if (isMegaJournal) {
            localStorage.setItem("dropdownToggleVal", "Author");
            window.location.href = "/dashboard";
          } else {
            setShowSubmitSuccessModal(true);
          }
        }}
        centered
        className="authorModal md-x"
        id="congratsMobile"
      >
        <Modal.Header className="modal-header" style={{ backgroundColor: "#006f94", color: "#ffffff" }}>
          <h5 className="modal-title mb-0" style={{ color: "#ffffff", fontWeight: "700" }}>
            Profanity Check Pending
          </h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            aria-label="Close"
            onClick={() => {
              setShowProfanityPendingModal(false);
              if (isMegaJournal) {
                localStorage.setItem("dropdownToggleVal", "Author");
                window.location.href = "/dashboard";
              } else {
                setShowSubmitSuccessModal(true);
              }
            }}
          ></button>
        </Modal.Header>
        <Modal.Body className="p-4 text-start">
          <p style={{ fontSize: "15px", color: "#374151", lineHeight: "1.6", margin: "10px 0", textAlign: "left" }}>
            Your article has been sent to Admin to review the use of words flagged as Profane. Admin will review the article and you will then receive an email for further action.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-0 pt-0 pb-4">
          <button
            className="button button-primary"
            type="button"
            style={{
              backgroundColor: "#006f94",
              borderColor: "#006f94",
              padding: "10px 32px",
              fontWeight: "700",
              borderRadius: "6px"
            }}
            onClick={() => {
              setShowProfanityPendingModal(false);
              if (isMegaJournal) {
                localStorage.setItem("dropdownToggleVal", "Author");
                window.location.href = "/dashboard";
              } else {
                setShowSubmitSuccessModal(true);
              }
            }}
          >
            Okay
          </button>
        </Modal.Footer>
      </Modal>

      {/* Upload Article Modal */}
      <Modal
        show={showUploadArticleModal}
        onHide={() => {
          setShowUploadArticleModal(false);
          if (!isUploadingArticle) {
            setUploadFile(null);
            setImageList([]);
          }
        }}
        centered
        size="lg"
        className="uploadArticleModal"
      >
        <div className="modal-header border-0 pb-0">
          <button
            type="button"
            className="btn-close ms-auto"
            onClick={() => {
              setShowUploadArticleModal(false);
              if (!isUploadingArticle) {
                setUploadFile(null);
                setImageList([]);
              }
            }}
          ></button>
        </div>
        <Modal.Body className="px-4 pb-4 pt-0 text-start">
          <div className="text-center mb-4">
            <div
              className="mx-auto mb-2 d-flex align-items-center justify-content-center"
              style={{
                width: "50px",
                height: "50px",
                borderRadius: "50%",
                backgroundColor: "#e6f4f8",
                color: "#006f94",
              }}
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="17 8 12 3 7 8" />
                <line x1="12" y1="3" x2="12" y2="15" />
              </svg>
            </div>
            <h4
              className="modal-title-main"
              style={{ color: "#006f94", fontWeight: "700", fontSize: "20px", marginBottom: "4px" }}
            >
              Upload Article Manuscript and Figures
            </h4>
            <p className="text-muted" style={{ fontSize: "13px", marginBottom: "0" }}>
              Upload your manuscript document first, then attach any figure images with title labels.
            </p>
          </div>

          <div className="d-flex flex-column gap-3 mb-4">
            {/* Step 1: Upload Document */}
            <div
              className="p-3 border rounded-3"
              style={{
                backgroundColor: uploadFile ? "#f0f7f9" : "#fafafa",
                borderColor: uploadFile ? "#006f94" : "#dee2e6",
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill"
                    style={{ backgroundColor: "#006f94", color: "#fff", fontSize: "11px" }}
                  >
                    STEP 1
                  </span>
                  <h6 className="mb-0" style={{ fontWeight: "700", color: "#006f94", fontSize: "15px" }}>
                    Upload Article Manuscript Document
                  </h6>
                </div>
                {uploadFile && <span className="badge bg-success" style={{ fontSize: "11px" }}>✓ Document Selected</span>}
              </div>

              {!uploadFile ? (
                <div
                  className="p-4 border border-dashed rounded-3 text-center"
                  style={{
                    backgroundColor: "#ffffff",
                    borderColor: "#006f94",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (documentInputRef.current) documentInputRef.current.click();
                  }}
                >
                  <div className="mb-2" style={{ color: "#006f94" }}>
                    <svg
                      width="36"
                      height="36"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M14 2H6a2 2 0 0 2-2 2v16a2 2 0 0 2 2 2h12a2 2 0 0 0 2-2V8z" />
                      <polyline points="14 2 14 8 20 8" />
                      <line x1="16" y1="13" x2="8" y2="13" />
                      <line x1="16" y1="17" x2="8" y2="17" />
                    </svg>
                  </div>
                  <h6 style={{ color: "#006f94", fontWeight: "600", marginBottom: "4px" }}>
                    Click here to select Manuscript Document
                  </h6>
                  <span className="text-muted" style={{ fontSize: "12px" }}>
                    Supports PDF, DOC, DOCX files (.pdf, .doc, .docx)
                  </span>
                </div>
              ) : (
                <div
                  className="p-3 rounded-3 bg-white border text-start"
                  style={{ borderColor: "#006f94" }}
                >
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex align-items-center gap-3 overflow-hidden">
                      <span style={{ fontSize: "24px" }}>📄</span>
                      <div className="overflow-hidden">
                        <h6
                          className="mb-0 text-truncate"
                          style={{ fontWeight: "600", color: "#333", fontSize: "14px" }}
                        >
                          {uploadFile.name}
                        </h6>
                        <span className="text-muted" style={{ fontSize: "12px" }}>
                          {(uploadFile.size / (1024 * 1024)).toFixed(2)} MB • Manuscript Document
                        </span>
                      </div>
                    </div>
                    <button
                      type="button"
                      className="btn border-0 p-1 ms-2"
                      style={{
                        background: "transparent",
                        color: "#dc3545",
                        fontSize: "18px",
                        fontWeight: "bold",
                        lineHeight: 1,
                        cursor: "pointer",
                        boxShadow: "none",
                      }}
                      onClick={() => {
                        setUploadFile(null);
                        setUploadErrorMessage("");
                      }}
                      disabled={isUploadingArticle}
                      title="Change file"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              )}
            </div>

            {/* Step 2: Supplementary Material (Enabled only after document is selected) */}
            <div
              className="p-3 border rounded-3"
              style={{
                backgroundColor: uploadFile ? "#ffffff" : "#f8f9fa",
                opacity: uploadFile ? 1 : 0.6,
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: uploadFile ? "#006f94" : "#6c757d",
                      color: "#fff",
                      fontSize: "11px",
                    }}
                  >
                    STEP 2
                  </span>
                  <h6
                    className="mb-0"
                    style={{
                      fontWeight: "700",
                      color: "#333",
                      fontSize: "15px",
                    }}
                  >
                    Supplementary Material{" "}
                    <span
                      className="text-muted fw-normal"
                      style={{ fontSize: "13px" }}
                    >
                      (Optional)
                    </span>
                  </h6>
                </div>
                {supplementaryList.length > 0 && (
                  <span
                    className="badge bg-info text-dark"
                    style={{ fontSize: "11px" }}
                  >
                    {supplementaryList.length}{" "}
                    {supplementaryList.length === 1 ? "File" : "Files"} Added
                  </span>
                )}
              </div>
              <p className="text-muted mb-3" style={{ fontSize: "12px" }}>
                Upload supplementary material (e.g. Datasets, Extended tables, or Multimedia files). Supports PDF, WORD, EXCEL, JPG/PNG files (.pdf, .doc, .docx, .xls, .xlsx, .jpg, .jpeg, .png).
              </p>

              {/* List of Uploaded Supplementary Files */}
              {supplementaryList.length > 0 && (
                <div className="d-flex flex-column gap-2 mb-3">
                  {supplementaryList.map((item) => (
                    <div
                      key={item.id}
                      className="p-2 border rounded-3 d-flex align-items-center justify-content-between gap-3"
                      style={{ backgroundColor: "#f9fbfd" }}
                    >
                      <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
                        <span style={{ fontSize: "22px", flexShrink: 0 }}>
                          {item.file.name.match(/\.(xlsx?|csv)$/i)
                            ? "📊"
                            : item.file.name.match(/\.(jpe?g|png)$/i)
                            ? "🖼️"
                            : "📄"}
                        </span>
                        <div className="flex-grow-1 overflow-hidden">
                          <h6
                            className="mb-0 text-truncate"
                            style={{
                              fontWeight: "600",
                              color: "#333",
                              fontSize: "13px",
                            }}
                          >
                            {item.file.name}
                          </h6>
                          <span
                            className="text-muted"
                            style={{ fontSize: "11px" }}
                          >
                            {(item.file.size / (1024 * 1024) >= 1)
                              ? `${(item.file.size / (1024 * 1024)).toFixed(2)} MB`
                              : `${(item.file.size / 1024).toFixed(1)} KB`}{" "}
                            • Supplementary File
                          </span>
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn border-0 p-1 ms-2"
                        style={{
                          background: "transparent",
                          color: "#dc3545",
                          fontSize: "18px",
                          fontWeight: "bold",
                          lineHeight: 1,
                          cursor: "pointer",
                          boxShadow: "none",
                        }}
                        onClick={() => handleRemoveSupplementaryFile(item.id)}
                        disabled={isUploadingArticle}
                        title="Remove file"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}

              {/* Add Supplementary File Button */}
              <button
                type="button"
                className="btn btn-sm"
                disabled={!uploadFile || isUploadingArticle}
                onClick={() => {
                  if (supplementaryInputRef.current)
                    supplementaryInputRef.current.click();
                }}
                style={{
                  backgroundColor: "#006f94",
                  color: "#ffffff",
                  borderColor: "#006f94",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  width: "auto",
                  minWidth: "fit-content",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                + Add Supplementary Material
              </button>
            </div>

            {/* Step 3: Upload Figures / Images */}
            <div
              className="p-3 border rounded-3"
              style={{
                backgroundColor: uploadFile ? "#ffffff" : "#f8f9fa",
                opacity: uploadFile ? 1 : 0.6,
                transition: "all 0.2s ease-in-out",
              }}
            >
              <div className="d-flex align-items-center justify-content-between mb-2">
                <div className="d-flex align-items-center gap-2">
                  <span
                    className="badge rounded-pill"
                    style={{
                      backgroundColor: uploadFile ? "#006f94" : "#6c757d",
                      color: "#fff",
                      fontSize: "11px",
                    }}
                  >
                    STEP 3
                  </span>
                  <h6 className="mb-0" style={{ fontWeight: "700", color: "#333", fontSize: "15px" }}>
                    Upload Figures / Images <span className="text-muted fw-normal" style={{ fontSize: "13px" }}>(Optional)</span>
                  </h6>
                </div>
                {imageList.length > 0 && (
                  <span className="badge bg-info text-dark" style={{ fontSize: "11px" }}>
                    {imageList.length} {imageList.length === 1 ? "Image" : "Images"} Added
                  </span>
                )}
              </div>
              <p className="text-muted mb-3" style={{ fontSize: "12px" }}>
                Upload figure images referenced in your manuscript and assign their figure labels (e.g. <code>fig 1</code>, <code>figure1.png</code>).
              </p>

              {imageList.length > 0 && (
                <div className="d-flex flex-column gap-2 mb-3">
                  {imageList.map((item) => (
                    <div
                      key={item.id}
                      className="p-2 border rounded-3 d-flex align-items-center justify-content-between gap-3"
                      style={{ backgroundColor: "#f9fbfd" }}
                    >
                      <div className="d-flex align-items-center gap-2 overflow-hidden flex-grow-1">
                        <img
                          src={URL.createObjectURL(item.file)}
                          alt="preview"
                          style={{
                            width: "42px",
                            height: "42px",
                            objectFit: "cover",
                            borderRadius: "6px",
                            border: "1px solid #dee2e6",
                          }}
                        />
                        <div className="flex-grow-1 overflow-hidden">
                          <label
                            className="form-label mb-1 text-muted fw-bold"
                            style={{ fontSize: "11px" }}
                          >
                            Figure Title / Label (e.g. fig 1, figure1.png)
                          </label>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={item.title}
                            onChange={(e) => handleUpdateImageTitle(item.id, e.target.value)}
                            placeholder="e.g. fig 1 or figure1.png"
                            disabled={isUploadingArticle}
                            style={{ fontSize: "13px" }}
                          />
                        </div>
                      </div>
                      <button
                        type="button"
                        className="btn border-0 p-1 ms-2"
                        style={{
                          background: "transparent",
                          color: "#dc3545",
                          fontSize: "18px",
                          fontWeight: "bold",
                          lineHeight: 1,
                          cursor: "pointer",
                          boxShadow: "none",
                        }}
                        onClick={() => handleRemoveImage(item.id)}
                        disabled={isUploadingArticle}
                        title="Remove image"
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              )}

              <button
                type="button"
                className="btn btn-sm"
                disabled={!uploadFile || isUploadingArticle}
                onClick={() => {
                  if (imageInputRef.current) imageInputRef.current.click();
                }}
                style={{
                  backgroundColor: "#006f94",
                  color: "#ffffff",
                  borderColor: "#006f94",
                  fontSize: "13px",
                  fontWeight: "600",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  width: "auto",
                  minWidth: "fit-content",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  whiteSpace: "nowrap",
                }}
              >
                + Add Image / Figure
              </button>
            </div>
          </div>

          <input
            type="file"
            ref={supplementaryInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,image/jpeg,image/png"
            multiple
            onChange={handleAddSupplementaryFiles}
          />
          <input
            type="file"
            ref={imageInputRef}
            style={{ display: "none" }}
            accept="image/*"
            multiple
            onChange={handleAddImages}
          />
          <input
            type="file"
            ref={documentInputRef}
            style={{ display: "none" }}
            accept=".pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            onChange={(e) => {
              if (e.target.files && e.target.files[0]) {
                setUploadFile(e.target.files[0]);
                setUploadErrorMessage("");
              }
            }}
          />

          <div className="d-flex flex-column align-items-center justify-content-center gap-2 mt-4 pt-3 border-top">
            {uploadErrorMessage && (
              <div
                className="alert alert-danger d-flex align-items-center justify-content-between w-100 mb-3"
                role="alert"
                style={{
                  borderRadius: "8px",
                  fontSize: "13px",
                  backgroundColor: "#f8d7da",
                  borderColor: "#f5c6cb",
                  color: "#721c24",
                  padding: "10px 14px",
                  margin: "0",
                }}
              >
                <div className="d-flex align-items-center gap-2">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={{ flexShrink: 0 }}
                  >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                  </svg>
                  <span>{uploadErrorMessage}</span>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px", boxShadow: "none" }}
                  onClick={() => setUploadErrorMessage("")}
                ></button>
              </div>
            )}
            {isUploadingArticle && (
              <div className="text-center w-100 mb-2">
                <span
                  style={{
                    color: "#dc3545",
                    fontWeight: "600",
                    fontSize: "14px",
                    display: "inline-block",
                  }}
                >
                  Extracting contents from document may take up to 5 minutes.
                </span>
              </div>
            )}
            <div className="d-flex align-items-center justify-content-center gap-3 w-100">
              <button
                type="button"
                className="btn btn-primary-custom"
                disabled={!uploadFile || isUploadingArticle}
                onClick={() => {
                  if (isMegaJournal && (!imageList || imageList.length === 0)) {
                    setShowNoFiguresModal(true);
                    return;
                  }
                  handleUploadArticleSubmit();
                }}
                style={{
                  padding: "12px 32px",
                  minWidth: "240px",
                  fontSize: "15px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                  borderRadius: "8px",
                }}
              >
                {isUploadingArticle ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Processing...
                  </>
                ) : (
                  "Review Submission"
                )}
              </button>

              <button
                type="button"
                className="btn btn-outline-primary-custom"
                onClick={() => {
                  setShowUploadArticleModal(false);
                  setUploadErrorMessage("");
                  if (!isUploadingArticle) {
                    setUploadFile(null);
                    setImageList([]);
                    setSupplementaryList([]);
                  }
                }}
                style={{
                  padding: "12px 32px",
                  minWidth: "160px",
                  fontSize: "15px",
                  fontWeight: "600",
                  whiteSpace: "nowrap",
                  borderRadius: "8px",
                }}
              >
                Close
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      {/* Mega Journal Figures Verification Modal */}
      <Modal
        show={showNoFiguresModal}
        onHide={() => setShowNoFiguresModal(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="figureNoticeModal"
        dialogClassName="figureNoticeModal"
        backdropClassName="figureNoticeModalBackdrop"
        style={{ zIndex: 1070 }}
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            borderRadius: "16px",
            overflow: "hidden",
            position: "relative",
            padding: "32px 28px 26px",
          }}
        >
          <button
            type="button"
            className="btn-close"
            style={{
              position: "absolute",
              right: "20px",
              top: "20px",
              fontSize: "12px",
              cursor: "pointer",
              boxShadow: "none",
            }}
            onClick={() => setShowNoFiguresModal(false)}
          ></button>

          <div className="text-center">
            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "50%",
                backgroundColor: "#FFF4EB",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: "16px",
              }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ef5c23"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
            </div>

            <h4
              style={{
                color: "#004c6c",
                fontWeight: "700",
                fontSize: "20px",
                marginBottom: "12px",
                textTransform: "none",
                letterSpacing: "normal",
              }}
            >
              Notice: Figures / Images
            </h4>

            <p
              style={{
                fontSize: "15px",
                color: "#4b5563",
                lineHeight: "1.6",
                marginBottom: "28px",
                padding: "0 10px",
                textAlign: "center",
              }}
            >
              Does your document contain images? If yes, you need to upload them
              separately. Images embedded in the PDF file will not display in the
              published article.
            </p>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "14px",
                width: "100%",
              }}
            >
              <button
                type="button"
                className="btn-outline-modal-action"
                onClick={() => setShowNoFiguresModal(false)}
                style={{
                  flex: 1,
                  height: "44px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                  padding: "0 16px",
                  minWidth: "0",
                }}
              >
                Upload Figures
              </button>
              <button
                type="button"
                className="btn-primary-modal-action"
                onClick={() => {
                  setShowNoFiguresModal(false);
                  handleUploadArticleSubmit();
                }}
                style={{
                  flex: 1,
                  height: "44px",
                  borderRadius: "8px",
                  fontWeight: "600",
                  fontSize: "14px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.2s ease",
                  padding: "0 16px",
                  minWidth: "0",
                }}
              >
                No figures to Upload
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}
export default perviewArticle;
